document.addEventListener("DOMContentLoaded", (event) => {
    /**
     * Flyout mobile: Toggle Flyout-menu
     */
    let burgerToggle = document.querySelector(
        "[data-mobile-navigation-button]"
    );
    burgerToggle.addEventListener("click", toggleMobileFlyOut, false);

    function toggleMobileFlyOut(e) {
        let burgerButton = e.target.closest("[data-mobile-navigation-button]");
        let navigation = document.querySelector("[data-mobile-navigation]");
        let menu = document.querySelector("[data-mobile-flyout]");

        if (burgerButton.classList.contains("is-active")) {
            burgerButton.classList.remove("is-active");
            menu.classList.remove("flyout-mobile--open");
            navigation.classList.remove("header-mobile__navigation--open");
        } else {
            burgerButton.classList.add("is-active");
            menu.classList.add("flyout-mobile--open");
            navigation.classList.add("header-mobile__navigation--open");
        }
    }

    const flyout = document.querySelector("[data-desktop-flyout]");
    if (flyout) {
        flyout.addEventListener("mouseleave", (event) => {
            flyout.classList.remove("flyout-desktop--open");
        });
    }

    /**
     * Flyout desktop: Open Flyout-menu on navigation-item hover (zero)
     */
    for (const element of document.querySelectorAll(
        ".header-desktop-menu__zero-list-item a"
    )) {
        element.addEventListener("mouseenter", (event) => {
            if (flyout) {
                const hasSubpages =
                    event.target.parentNode.className.includes("--hasSubpages");
                if (hasSubpages) {
                    flyout.classList.add("flyout-desktop--open");
                    // show first level elements
                    const page = event.target.dataset.page;
                    if (page) {
                        for (const element of document.querySelectorAll(
                            "[data-parent-zero]"
                        )) {
                            if (element.dataset.parentZero === page) {
                                element.classList.remove("hidden");
                            } else {
                                element.classList.add("hidden");
                            }
                        }
                        for (const element of document.querySelectorAll(
                            "[data-parent-one]"
                        )) {
                            element.classList.add("hidden");
                        }
                        for (const element of document.querySelectorAll(
                            "[data-parent-two]"
                        )) {
                            element.classList.add("hidden");
                        }
                    }
                } else {
                    flyout.classList.remove("flyout-desktop--open");
                }
            }
            updateView();
        });

        element.addEventListener("mouseleave", (event) => {});
    }

    /**
     * Flyout desktop: Open Flyout-menu on navigation-item hover (one)
     */
    for (const element of document.querySelectorAll(
        ".flyout-desktop__one-link"
    )) {
        element.addEventListener("mouseenter", (event) => {
            const page = event.target.dataset.page;
            if (page) {
                const targets = document.querySelectorAll("[data-parent-one]");
                for (const target of targets) {
                    if (target.dataset.parentOne === page) {
                        target.classList.remove("hidden");
                    } else {
                        target.classList.add("hidden");
                    }
                }
            }
            updateView();
        });
    }

    /**
     * Flyout mobile: Add class to navigation on scroll
     */
    let scrollPositionY = window.scrollY;
    let headerMobileSelector = document.getElementsByClassName(
        "header-mobile__navigation"
    );
    window.addEventListener("scroll", setMobileHeaderScrollState);

    function setMobileHeaderScrollState() {
        scrollPositionY = window.scrollY;
        if (scrollPositionY >= 50) {
            headerMobileSelector[0].classList.add(
                "header-mobile__navigation--scrolled"
            );
        } else {
            headerMobileSelector[0].classList.remove(
                "header-mobile__navigation--scrolled"
            );
        }
    }
    setMobileHeaderScrollState();

    /**
     * Flyout desktop: Add class to navigation on scroll
     */
    let headerDesktopSelector = document.getElementsByClassName(
        "header-desktop__navigation"
    );
    window.addEventListener("scroll", setDesktopHeaderScrollState);

    function setDesktopHeaderScrollState() {
        scrollPositionY = window.scrollY;
        if (scrollPositionY >= 50) {
            headerDesktopSelector[0].classList.add(
                "header-desktop__navigation--scrolled"
            );
        } else {
            headerDesktopSelector[0].classList.remove(
                "header-desktop__navigation--scrolled"
            );
        }
    }
    setDesktopHeaderScrollState();

    const imageContainer = document.querySelector(
        ".flyout-desktop__image-container"
    );
    if (imageContainer) {
        for (const node of document.querySelectorAll("[data-image-by-page]")) {
            node.addEventListener("mouseenter", (event) => {
                onFlyoutNavlinkMouseenter(event, imageContainer);
            });
            node.addEventListener("mouseleave", (event) => {
                onFlyoutNavlinkMouseleave(event, imageContainer);
            });
        }
    }

    function onFlyoutNavlinkMouseenter(event, imageContainer) {
        for (const image of imageContainer.querySelectorAll("img")) {
            if (image.dataset.fromPage === event.target.dataset.imageByPage) {
                image.classList.remove("hidden");
            } else {
                image.classList.add("hidden");
            }
        }
    }

    function onFlyoutNavlinkMouseleave(event, imageContainer) {
        for (const image of imageContainer.querySelectorAll("img")) {
            image.classList.add("hidden");
        }
    }

    for (const node of document.querySelectorAll(".search-toggle")) {
        node.addEventListener("click", () => {
            const searchCanvas = document.querySelector("[data-search-canvas]");
            if (searchCanvas) {
                searchCanvas.classList.toggle("innerCanvas--shown");
            }
        });
    }

    for (const node of document.querySelectorAll(
        "[data-search-canvas] .button--close"
    )) {
        node.addEventListener("click", () => {
            const searchCanvas = document.querySelector("[data-search-canvas]");
            if (searchCanvas) {
                searchCanvas.classList.remove("innerCanvas--shown");
            }
        });
    }

    function updateView() {
        const flyoutTwoList = document.querySelector(
            ".flyout-desktop__two-list"
        );
        if (flyoutTwoList) {
            if (flyoutTwoList.querySelectorAll("li:not(.hidden)").length > 0) {
                flyoutTwoList.classList.remove("hidden");
            } else {
                flyoutTwoList.classList.add("hidden");
            }
        }
    }
});
